import {
  AGREGAR_FAVORITO,
  APPEND_VIDEOS,
  CLEAR_RELOAD,
  CREATE_VIDEO,
  ELIMINAR_FAVORITO,
  FAVORITOS_RECIBIDOS,
  HIDE_SPINNER,
  PURCHASE_NEEDED,
  RELOAD_VIDEOS,
  SET_PROPIEDAD_VIDEO,
  SHOW_SPINNER,
  SINGLE_VIDEO_RECIBIDO,
  VIDEOS_RECIBIDOS,
} from "../types";

const schema = {
  video_id: "nuevo",
  description: "",
  name: "",
  restricted: "",
  thumbnail: "",
  url: "",
  url_preview: "",
  instructor_id: "",
  video_type_id: "",
  video_type: "",
};

export default (state, { type, payload }) => {
  switch (type) {
    case RELOAD_VIDEOS:
      return { ...state, reloadVideos: true, spinner: true };
    case CLEAR_RELOAD:
      return { ...state, reloadVideos: false };
    case SHOW_SPINNER: {
      return { ...state, spinner: true };
    }
    case HIDE_SPINNER: {
      return { ...state, spinner: false, reloadVideos: false };
    }
    case CREATE_VIDEO: {
      return { ...state, video: schema };
    }
    case FAVORITOS_RECIBIDOS:
      return { ...state, favoritos: payload };
    case APPEND_VIDEOS: {
      let videos = state.videos;
      if (videos === null) videos = payload;
      else videos = [...videos, ...payload];
      return { ...state, videos, reloadVideos: false };
    }
    case VIDEOS_RECIBIDOS: {
      return { ...state, videos: payload, reloadVideos: false };
    }
    case SINGLE_VIDEO_RECIBIDO:
      return { ...state, video: payload };
    case AGREGAR_FAVORITO: {
      const videos = [...state.videos];
      const index = videos.findIndex((video) => video.video_id === payload);
      if (index !== -1) {
        videos[index].favorite = 1;
      }
      return { ...state, videos };
    }
    case ELIMINAR_FAVORITO: {
      const videos = [...state.videos];
      const index = videos.findIndex((video) => video.video_id === payload);
      if (index !== -1) {
        videos[index].favorite = 0;
      }
      return { ...state, videos };
    }
    case SET_PROPIEDAD_VIDEO: {
      const { key, value } = payload;
      const video = { ...state.video };
      video[key] = value;
      return { ...state, video };
    }
    case PURCHASE_NEEDED:
      return { ...state, purchase_needed: true };
    case SHOW_SPINNER:
      return { ...state, spinner: true };
    case HIDE_SPINNER:
      return { ...state, spinner: false };
    default:
      return { ...state };
  }
};
